import { render, staticRenderFns } from "./CnStock.vue?vue&type=template&id=4d1444f4&scoped=true"
import script from "./CnStock.vue?vue&type=script&lang=js"
export * from "./CnStock.vue?vue&type=script&lang=js"
import style0 from "./CnStock.vue?vue&type=style&index=0&id=4d1444f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1444f4",
  null
  
)

export default component.exports